import { create } from "zustand";

const useMoreItemStore = create(
    (set) => ({
        hasStore: false,
        types: [],
        mainTag: [],
        secondaryTag: [],
        brand: [],
        search: "",
        setHasStore: (hasStore) => set({ hasStore }),
        removeHasStore: () => set({ hasStore: false }),
        setTypes: (types) => set({ types }),
        removeTypes: () => set({ types: [] }),
        setMainTag: (mainTag) => set({ mainTag }),
        removeMainTag: () => set({ mainTag: [] }),
        setSecondaryTag: (secondaryTag) => set({ secondaryTag }),
        removeSecondaryTag: () => set({ secondaryTag: [] }),
        setBrand: (brand) => set({ brand }),
        removeBrand: () => set({ brand: [] }),
        setSearch: (search) => set({ search }),
        removeSearch: () => set({ search: "" }),
        removeAll: () => set({ hasStore: false, types: [], mainTag: [], secondaryTag: [], brand: [], search: "" }),
    })
)
    
export default useMoreItemStore;
